import React, { useEffect } from 'react';
import { Loading } from 'components/Loading/Loading';
import axiosInstance from '../../utils/axiosInstance';
import { authXConfig } from 'router/authx-config';
import { useRematchDispatch } from 'models/rematchStore';

const AuthLogoutComponent = () => {
    const dispatch = useRematchDispatch();
    useEffect(() => {
        const logout = async () => {
            try {
                const response = await axiosInstance.get(
                    authXConfig.API.CognitoAPI.logoutURL,
                    {},
                    {
                        withCredentials: true, // ✅ important if cookies/session exist
                    }
                );
                if (response.status === 200) {
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('refresh_token');
                    localStorage.removeItem('id_token');
                    localStorage.removeItem('auth_code');
                    console.log('logout response', response);
                    window.location.href = response.data;
                }
            } catch (error) {
                console.error('Logout API failed:', error);
                // in case of logout api error do not do anything
                // localStorage.removeItem('access_token');
                // localStorage.removeItem('refresh_token');
                // localStorage.removeItem('id_token');
            }
        };

        logout();
    }, []);

    return <Loading />;
};

export const AuthLogout = AuthLogoutComponent;
